import { Box, Typography } from "@mui/material";
import React from "react";

const GlassPanel = React.memo(({ title, children }) => (
    <Box
        sx={{
            p: 3,
            borderRadius: 4,
            bgcolor: "rgba(255,255,255,0.05)",
            backdropFilter: "blur(16px)",
            border: "1px solid rgba(255,255,255,0.12)",
            boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
        }}
    >
        {title && (
            <Typography
                sx={{
                    fontWeight: 600,
                    mb: 2,
                    fontSize: 18,
                    opacity: 0.85,
                }}
            >
                {title}
            </Typography>
        )}

        {children}
    </Box>
));

export default GlassPanel;
